// extracted by mini-css-extract-plugin
export default {"bidAllBtn":"AuctionListPage-module__bidAllBtn--rQIjF"};